import { Routes } from '@angular/router';
import { DictationDigitalPage } from './dictation-digital-page/dictation-digital-page';
import { DictationPage } from './dictation-page';
import { DictationPhysicalPage } from './dictation-physical-page/dictation-physical-page';
import { DictationSentencesPage } from './dictation-sentences-page/dictation-sentences-page';
import { DictationVisualPage } from './dictation-visual-page/dictation-visual-page';

export const mechanicDictationRoutes: Routes = [
  {
    path: '',
    component: DictationPage,
  },
  {
    path: 'physical',
    component: DictationPhysicalPage,
  },
  {
    path: 'visual',
    component: DictationVisualPage,
  },
  {
    path: 'digital',
    component: DictationDigitalPage,
  },
  {
    path: 'sentences',
    component: DictationSentencesPage,
  },
];
